import gridbase from "../../../components/gridComponentBase.js";
import moment from "moment";
import helpers from "../../../shared/fleetbox-helpers";
import { mapGetters } from "vuex";
import { bus } from "../../../main";

export default {
	extends: gridbase,
	components: {},
	props: {
		config: Array,
		data: Array,
		gridClass: String,
		eventsFilter: Array,
		eventsFilterSelected: Array,
		vehicleIdFilterField: String,
		driverItemsFilter: Array,
		driversSelectedFilter: Array,

		totalEventCount: Number
	},
	data: function() {
		return {
			columns: [
				{
					field: "visible",
					configId: "",
					title: "",
					width: "45",
					headerCell: "myHeaderImagesSwitchTemplate",
					sortable: false,
					cell: "myCellTemplate",
					format: "booleanSwitch",
					className: "swtcAlarms",
					configByPass: true
				},
				{
					field: "number_plate",
					configId: "number_plate",
					title: "targa",
					width: "85",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false
				},
				{
					field: "vehicle_code",
					configId: "vehicle_code",
					title: "codice",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false
				},
				{
					field: "driver_name",
					configId: "driver_name",
					title: "conducente",
					width: "150",
					headerCell: "myDriverHeaderTemplate",
					format: "",
					filterable: true
				},
				{
					field: "event_date",
					configId: "event_date",
					title: "data",
					width: "150",
					headerCell: "myDateHeaderTemplate",
					cell: "myCellTemplate",
					format: "datetime",
					filterable: true
				},
				{
					field: "diagnostic_description",
					configId: "description",
					width: "350",
					title: "Descrizione",
					headerCell: "myDescriptionEventHeaderTemplate",
					format: "",
					filterable: true,
					sortable: false
				},
				{
					field: "",
					configId: "",
					title: "",
					width: "",
					headerCell: "",
					format: "",
					filterable: false,
					sortable: false,
					configByPassByField: "parameter"
				},
				{
					field: "um",
					configId: "unit",
					title: "UM",
					headerCell: "myHeaderTemplate",
					format: "",
					width: "80",
					filterable: false,
					sortable: false
				},
				{
					field: "value",
					configId: "value",
					title: "Valore",
					headerCell: "myHeaderTemplate",
					format: "",
					width: "173",
					filterable: false,
					sortable: false
				},
				{
					field: "parameter",
					configId: "parameter",
					title: "Parametro",
					width: "350",
					headerCell: "myHeaderTemplate",
					sortable: false,
					filterable: false,
					cell: "myCellTemplate"
				}
			],
			htIndex: 0
		};
	},

	created() {
		var self = this;

		//this.columnsToShow = this.columns;
		this.hasSelectedMode = true;
		this.query.pageSize = 25;
		this.take = 25;

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
			this.take = parseInt(this.settings.defaultPageSize);
		}

		this.items = this.data;
		this.total = this.totalEventCount;
		bus.$on("alarm-marker-click", self.markerClickHandler.bind(self));
		bus.$on("on-summary-get-data", self.onSummaryGetData.bind(self));
		bus.$on("header-filter-change", self.onHeaderFilterChange.bind(self));
	},
	watch: {
		data: {
			handler() {
				this.items = this.data;
				this.total = this.totalEventCount;
			},
			deep: true
		},
		config: function() {
			this.columnsToShow = [];
			this.changeConfigColumns();
		}
	},
	beforeDestroy() {
		var self = this;
		bus.$off("alarm-marker-click");
		bus.$off("on-category-summary-selected");
		bus.$off("header-filter-change");
	},
	/* metodi */
	methods: {
		changeConfigColumns: function() {
			var self = this;
			self.columnsToShow = [];

			if (self.config && self.config.length > 0) {
				var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

				orderedConfigColumn.forEach(column => {
					var defColumn = self.columns.find(function(f) {
						return f.configId === column.field;
					});

					if (defColumn && column.enabled) {
						defColumn.title = column.label;

						self.columnsToShow.push(defColumn);
					}
				});

				if (self.columnsToShow.length > 0) {
					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						var index = columnsByPassConfig[i].order || 0;
						self.columnsToShow.splice(index, 0, columnsByPassConfig[i]);
					}

					var columnsByPassByField = self._.filter(self.columns, function(item) {
						return item.configByPassByField && item.configByPassByField.length > 0;
					});

					for (var i = 0; i < columnsByPassByField.length; i++) {
						var clBPf = columnsByPassByField[i];
						var columnRootIndex = self.columnsToShow.findIndex(function(cl) {
							return clBPf.configByPassByField == cl.field;
						});

						if (columnRootIndex < 0) columnRootIndex = self.columnsToShow.length;

						self.columnsToShow.splice(columnRootIndex + 1, 0, clBPf);
					}
				}
			}
			self.htIndex++;
		},
		onHeaderFilterChange() {
			this.skip = 0;
			this.query.page = 0;
		},
		onSummaryGetData() {
			this.skip = 0;
			this.query.page = 0;
			// this.$emit("diagnostic-get-data", {
			// 	sort: this.sort,
			// 	page: this.query.page,
			// 	pageSize: this.query.pageSize
			// });
		},
		filterHandler(e) {
			if (e.filterable) {
				this.skip = 0;
				this.query.page = 0;

				if (e.field == "diagnostic_description") {
					this.$emit("ht-event-filter-handler", {
						sort: this.sort,
						page: this.query.page,
						pageSize: this.query.pageSize
					});

					return;
				}

				if (e.filterType == "daterange") {
					this.$emit("filter-daterange-change", {
						startDate: e.startDateHeader,
						endDate: e.endDateHeader,
						type: "date",
						reset: false
					});
				}

				this.$emit("ht-filter-handler", {
					sort: this.sort,
					page: this.query.page,
					pageSize: this.query.pageSize
				});
			}
		},
		removeFilterHandler(e) {
			if (e.filterable) {
				this.skip = 0;
				this.query.page = 0;
				if (e.field == "diagnostic_description") {
					this.eventsFilterSelected.splice(0, this.eventsFilterSelected.length);
					this.$emit("ht-event-filter-handler", {
						sort: this.sort,
						page: this.query.page,
						pageSize: this.query.pageSize
					});

					return;
				}
				if (e.field == "driver_name") {
					this.driversSelectedFilter.splice(0, this.driversSelectedFilter.length);
				}
				if (e.field == "event_date") {
					this.$emit("filter-daterange-change", {
						startDate: null,
						endDate: null,
						type: null,
						reset: true
					});
				}
				this.$emit("ht-filter-handler", {
					sort: this.sort,
					page: this.query.page,
					pageSize: this.query.pageSize
				});
			}
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.$emit("diagnostic-get-data", {
				sort: this.sort,
				page: this.query.page,
				pageSize: this.query.pageSize
			});
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.$emit("diagnostic-get-data", {
				sort: this.sort,
				page: this.query.page,
				pageSize: this.query.pageSize
			});
		},
		onHeaderVisibleChange(visible) {
			for (var i = 0; i < this.data.length; i++) {
				var item = this.data[i];
				if (item && this._.isNull(item.visible) === false) {
					item.visible = visible;
					this.$emit("on-visibility-item-change", item);
				}
			}
		},
		booleanSwitchChange(e) {
			if (e.field === "visible") {
				this.$emit("on-visibility-item-change", e.dataItem);
			}

			this.selectRow(e.dataItem);
		},
		markerClickHandler(e) {
			if (e && e.marker) {
				var itemToSelect = this._.find(this.items, function(x) {
					return x.id === e.marker.id;
				});

				if (itemToSelect) {
					this.selectRow(itemToSelect);
				}
			}
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		getData() {
			this.$emit("diagnostic-get-data", {
				sort: this.sort,
				page: this.query.page,
				pageSize: this.query.pageSize
			});
		}
	},
	computed: {
		...mapGetters(["settings"]),
		driversFilter() {
			return this.driverItemsFilter.map(function(item) {
				return {
					id: item.id,
					value: `${item.surname} ${item.name}`
				};
			});
		},
		allAreShown() {
			var self = this;
			if (this.data && this.data.length > 0) {
				var filtersData = this.data.filter(function(item) {
					return self._.isNull(item.visible) === false;
				});

				if (filtersData.length > 0) {
					return filtersData.every(function(item) {
						return item.visible == true;
					});
				}

				return false;
			}

			return false;
		}
	}
};
